import { createSlice } from '@reduxjs/toolkit'
import { sortByProp } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { SCHEMA } from '../constants'
import { handleScaleDataTable } from '../helpers'
import { getIndustryScaleTable } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/industryScale',
  initialState: {
    isLoading: true,
    headers: [],
    ids: [],
    data: {},
    isFirstLoad: false,
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.headers = []
      state.ids = []
      state.data = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getIndustryScaleTable.pending, (state) => {
      state.isLoading = true
      state.headers = []
      state.ids = []
      state.data = {}
    })
    builder.addCase(
      getIndustryScaleTable.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        state.isFirstLoad = true

        if (payload.length) {
          state.ids = Object.keys(SCHEMA)
          state.headers = sortByProp(
            payload.map(({ year }) => ({
              label: year,
              key: year,
            })),
            'key',
            false,
          )
          state.data = handleScaleDataTable(payload, state.headers)
        }
      },
    )

    builder.addCase(getIndustryScaleTable.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
      state.isFirstLoad = true
    })
  },
})

export const selectIds = (state) => state[slice.name].ids
export const selectIsLoadingScale = (state) => state[slice.name].isLoading
export const selectIsFirstLoadScale = (state) => state[slice.name].isFirstLoad
export const selectItem = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}
export const selectTableTitle = (state) => state[slice.name].headers

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
